import * as React from 'react';
import classNames from 'classnames';
import { useState } from 'react';
import { includes } from 'lodash';

import FilterItem from '../FilterItem';
import Button from '../Button';
import Buttons from '../Buttons';
import Icon from '../Icon';

export interface IFiltersProps {
    labelShowAll?: string;
    labelShowLess?: string;
    isOverlay?: boolean;
}

const Filters: React.FunctionComponent<IFiltersProps> = (props) => {
    // Main output
    const [hiddenFilters, setHiddenFilters] = React.useState<{
        [key: string]: boolean | undefined;
    }>({});
    const [showAll, setShowAll] = React.useState<boolean>(false);

    return (
        <React.Fragment>
            <div id="product-filters-wrapper" className={classNames('product-filters__form-row', showAll && 'wrap')}>
                {React.Children.map(props.children, (child: any, i) => {
                    if(typeof child === 'string') {
                        return null;
                    } else {
                        return (
                            <FilterItem
                                key={i}
                                isOverlay={props.isOverlay}
                                setHidden={(isHidden) => {
                                    setHiddenFilters({
                                        ...hiddenFilters,
                                        [i]: isHidden,
                                    });
                                }}
                            >
                                {child}
                            </FilterItem>
                        );
                    }
                })}
            </div>
            <Buttons>
                {Object.keys(hiddenFilters).filter((key) => {
                return hiddenFilters[key];
            }).length > 0 && !showAll && (
                    <Button
                        intent="secondary-muted"
                        size="xsmall"
                        onClick={() => setShowAll(true)}
                        title={(<React.Fragment><Icon kind="arrow5-down" width={14} height={14}/><span>{props.labelShowAll}</span></React.Fragment>)}
                    />
             )}
                { showAll && (
                    <Button
                        intent="secondary-muted"
                        size="xsmall"
                        onClick={() => setShowAll(false)}
                        title={(<React.Fragment><Icon kind="arrow5-up" width={14} height={14}/><span>{props.labelShowLess}</span></React.Fragment>)}
                    />
                )}
            </Buttons>
        </React.Fragment>
    );
};

Filters.displayName = 'Filters';

export default Filters;
